import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/lib/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/login")({
	component: LoginPage,
});

function LoginPage() {
	const login = useAuthStore((s) => s.login);
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
	const navigate = useNavigate();
	const { t } = useTranslation();

	useEffect(() => {
		if (isAuthenticated) {
			navigate({ to: "/" });
		}
	}, [isAuthenticated, navigate]);

	if (isAuthenticated) return null;

	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-background gap-6">
			<div className="text-center space-y-1">
				<h1 className="text-2xl font-semibold tracking-tight">OmniOS</h1>
				<p className="text-sm text-muted-foreground">
					{t("corporate_platform")}
				</p>
			</div>
			<Button size="lg" onClick={login}>
				{t("login_zitadel")}
			</Button>
		</div>
	);
}
